import { useTranslate } from "ra-core";
import { Badge } from "@/components/ui/badge";
import type { PaymentStatus } from "../../types";

export const PaymentStatusBadge = ({ status }: { status?: PaymentStatus }) => {
  const translate = useTranslate();
  if (!status) return null;

  const variant = status === "overdue" ? "destructive" : "secondary";

  return (
    <Badge variant={variant}>
      {translate(`resources.payments.statuses.${status}`, { _: status })}
    </Badge>
  );
};
